import { KeypadContext } from '@3plearning/question-components-library';
import React, { useContext } from 'react';
import { Box, Img, Button } from '@chakra-ui/react';

import keypadIcon from '../../../assets/images/keypad.svg';

const Keypad = () => {
  const {
    showKeypad, setShowKeypad, showKeypadBtn, isKeypadBtnDisabled
  } = useContext(KeypadContext);

  if (!showKeypadBtn) {
    return null;
  }

  const onKeypadToggle = (event) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    setShowKeypad(!showKeypad);
  };

  return (
    <Button
      w={'42px'}
      h={'42px'}
      px={'5px'}
      left={0}
      bottom={'40px'}
      transform={'translate(-50%, 0)'}
      zIndex={96}
      borderRadius={'full'}
      position={'absolute'}
      variant={'read-aloud'}
      isDisabled={isKeypadBtnDisabled}
      isActive={showKeypad && !isKeypadBtnDisabled}
      onMouseDown={onKeypadToggle}
      _disabled={{
        _hover: { bg: 'neutral.100' },
        bg: 'neutral.100',
        borderColor: 'neutral.200',
        cursor: 'not-allowed'
      }}
      _active={{ bg: 'primary.300' }}
    >
      <Box as={'span'} borderRadius={'4px'} bg={'white'}><Img src={keypadIcon} mr={'-5px'} my={'-1px'} /></Box>
    </Button>
  );
};

export default Keypad;
